// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2fWA0","colMin":"styles_colMin__2MIud","colCheckbox":"styles_colCheckbox__G2tJj"};